import React, { useRef } from 'react'
import { Col, Icon, Modal, notification, Row } from 'antd'
import { Formik } from 'formik'
import { useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { Button, Table } from 'src/components/Ant'
import { ColumnProps } from 'src/components/Ant/Table'
import { Empty } from 'src/components/atoms'
import { PolicyTree } from 'src/types'
import { Select } from 'src/components/Formik'
import { useT } from 'src/core/hooks/use-translation'
import * as PoliciesTreeService from 'src/services/api/policies-trees'
import history from 'src/config/routes/history'

import * as CSS from './styles'

import { HierarchyProps } from '../tree-side-options'

export default function HierarchyPolicies({
  loading,
  policies,
  policyTree,
  resetPoliciesTrees,
  treesSelected
}: HierarchyProps) {
  const { me } = useSelector((state: ApplicationState) => ({
    me: state.me
  }))

  const refFormik = useRef()
  const { t } = useT()

  if (!treesSelected?.id) {
    return <Empty />
  }

  const columns: ColumnProps<PolicyTree>[] = [
    {
      dataIndex: 'policy.name',
      key: 'name',
      title: 'web.tree.policies.table.name'
    },
    {
      dataIndex: 'policy.description',
      key: 'description',
      title: 'web.tree.policies.table.description'
    }
  ]

  const optionsPolicies = policies?.map(policy => ({
    value: String(policy.policy_id),
    label: policy.name
  }))

  function LinkPolicyTree(value: any) {
    Modal.confirm({
      cancelText: t('common.actions.cancel'),
      content: t('web.tree.policies.modal.message'),
      onOk: () =>
        PoliciesTreeService.save({
          assign_tree_id: treesSelected.id,
          organization_id: me.organization.organization_id,
          policy: 'policy_id',
          policy_id: value.policy
        })
          .then(response => {
            if (response.status === 200) {
              resetPoliciesTrees()
            } else {
              notification.error({
                message: t('common.response.status-500'),
                placement: 'bottomRight'
              })
            }
          })
          .catch(() => {
            notification.error({
              message: t('common.response.status-500'),
              placement: 'bottomRight'
            })
          })
    })
  }

  return (
    <div>
      <Formik
        initialValues={{ policy: '' }}
        onSubmit={LinkPolicyTree}
        ref={refFormik}
        render={formikProps => (
          <Row>
            <Col span={15}>
              <Select
                dataTestId="policy-list"
                formikProps={formikProps}
                label={'web.tree.policies.title'}
                name="policy"
                options={optionsPolicies}
                placeholder="common.actions.select"
                required={false}
              />
            </Col>
            <Col span={9}>
              <Button
                disabled={!formikProps.values.policy}
                type="default"
                onClick={() => {
                  history.push(`/policies/edit/${formikProps.values.policy}`)
                }}
                style={{ margin: '40px 10px 0px 10px' }}
              >
                <Icon key="eye" type="eye" />
              </Button>

              <Button
                disabled={!formikProps.values.policy}
                onClick={() => {
                  formikProps.submitForm()
                }}
              >
                {t('web.tree.policies.link')}
              </Button>
            </Col>
          </Row>
        )}
      />

      <div>
        <CSS.Div>
          <Table
            dataSource={policyTree?.[0]?.policy_id ? policyTree : []}
            loading={loading}
            className="table-striped"
            columns={columns}
            size="small"
          />
        </CSS.Div>
      </div>
    </div>
  )
}
